import { render } from "./AdminAppsDetails.vue?vue&type=template&id=7afa6b12"
import script from "./AdminAppsDetails.vue?vue&type=script&lang=js"
export * from "./AdminAppsDetails.vue?vue&type=script&lang=js"

import "./AdminAppsDetails.vue?vue&type=style&index=0&id=7afa6b12&lang=css"

import exportComponent from "/home/pzborow/works/gunb/rwdzold/dev/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__